export const environment =
{
  "production": true,
  "baseUrl": "https://fms.allcaresoftware.com/",
  "onboardingUrl": "https://fms.allcaresoftware.com/",
  "uiVresion": "1.0.8",
  "hosturl": "https://fms.allcaresoftware.com/",
  "utilizationReportId": "c2bbd2d2-019a-4ba1-b410-aac445038640",
  "revenueReportId": "c272d8f7-b6d4-4a00-b6b6-4a9ad9338846",
  "ClaimVsPaidReportId": "22acad14-1082-478b-af83-da805286a391",
  "utilizationSummaryReportId": "14834977-a5de-462e-a360-3bd69536a599",
  "reportId": "0e1375a9-858c-4247-a259-b8b96047bc23",
  "reportId835": "8fbf6fd0-b8b3-4251-a46e-ca25c4b60fef",
  "reportId837": "b720940d-b521-4de3-9ec5-81c28bc3bb37",
  "APMServerURL": 'https://apmrum.allcaresoftware.com',
   "environment": 'production',
}
